<script lang="ts" setup>
  import type { Dayjs } from 'dayjs';
  import AsteriskText from '~/components/shared/Forms/AsteriskText.vue';
  import InformationCircle from '../Others/InformationCircle.vue';

  const props = defineProps<{
    labelText: string;
    value: Date | Dayjs | null | string;
    format?: string;
    stateKey: string;
    name: string;
    picker?: string;
    rules?: any;
    isCompulsory?: boolean;
    addInfoText?: string;
    disabled?: boolean;
    allowClear?: boolean;
    width?: string;
    dateClass?: string;
    labelWidth?: string;
  }>();

  const localValue = ref<Date | Dayjs | null | string>(props.value);

  const emit = defineEmits(['update:value']);

  watch(
    () => props.value,
    newValue => {
      localValue.value = newValue;
    }
  );

  watch(
    () => localValue.value,
    newValue => {
      emit('update:value', newValue, props.stateKey);
    }
  );
</script>
<template>
  <a-form-item
    class="!font-medium custom-date-component"
    :name="props.name"
    :rules="props.rules"
    :label-col="props.labelWidth ? { style: { width: props.labelWidth } } : undefined"
  >
    <template #label>
      <AsteriskText v-if="props.isCompulsory" :label="props.labelText" />
      <p v-else class="text-zinc-600">{{ props.labelText }}</p>
      <InformationCircle v-if="props.addInfoText" :title="props.addInfoText" class="ml-2" />
    </template>
    <a-date-picker
      v-model:value="localValue"
      :format="props.format || 'DD/MM/YYYY'"
      :picker="props.picker"
      placeholder=""
      :class="[width ? `${width} p-2 leading-[21px]` : 'w-[248px] p-2 leading-[21px]', dateClass]"
      :disabled="props.disabled"
      :allow-clear="props.allowClear"
    />
  </a-form-item>
</template>

<style>
  .custom-date-component .ant-form-item-row .ant-form-item-label > label {
    line-height: 21px;
  }

  .custom-date-component #form_item_accountingDate {
    line-height: 21px !important;
    font-weight: 500 !important;
    color: #27272a !important;
  }

  .custom-date-component #form_item_accountingDate-placeholder {
    line-height: 21px !important;
    font-weight: 500 !important;
  }

  .custom-date-component .ant-picker-disabled input {
    color: #27272a !important;
  }
</style>
